<template>
  <div
    class="content has-text-left"
    :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
  >
    <div
      id="clientDetails"
      class="modal"
    >
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title"></p>
          <div
            class="is-pulled-left"
            :class="{'is-pulled-right': Language == 'fa' || Language == 'ar', 'is-pulled-left': Language != 'fa' && Language != 'ar'}"
          >
            <h1
              class="title"
              v-if="modal.client.full_name"
            >{{modal.client.full_name}}</h1>
            <p class="subtitle">
              <span v-if="modal.client.total_commission_generated">{{$t('commission').tTitle()}}: {{currencies['USD'].symbol}}{{modal.client.total_commission_generated.toFixed(2)}}</span>
              <span v-if="modal.client.volume_traded">| {{$t('volume').tTitle()}}: {{modal.client.volume_traded}}</span>
            </p>
          </div>
          <div
            class="is-flex-widescreen dates"
            :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
          >
            <span v-if="dateFrom">
              <h4 class="title is-8">{{$t('date_from').tTitle()}}:</h4>
              <p class="subtitle is-6">
                <span>{{$formatDateTime(dateFrom)}}</span>
              </p>
            </span>
            <span v-if="dateTo">
              <h4 class="title is-8">{{$t('date_to').tTitle()}}:</h4>
              <p class="subtitle is-6">
                <span>{{$formatDateTime(dateTo)}}</span>
              </p>
            </span>
          </div>
          <button
            class="delete"
            @click="closeClientDetailsModal()"
          ></button>
        </header>
        <section class="modal-card-body talist">
          <div class="columns">
            <div class="column is-3-desktop">
              <nav
                class="panel"
                :class="{'mobile-active': modal.TAListActive}"
              >
                <p
                  class="panel-heading"
                  @click="modal.TAListActive = !modal.TAListActive"
                >
                  {{$t('trading_accounts').tTitle()}}
                  <span class="icon is-pulled-right is-hidden-desktop">
                    <i class="fa fa-bars"></i>
                  </span>
                </p>
                <a
                  class="panel-block is-hidden-touch"
                  v-for="ta in modal.ta"
                  :class="{'is-active': ta.external_id == modal.selected.ta.external_id}"
                  @click="modal.cLogsPage = 1, modal.selected.ta = ta, modal.TAListActive = false, getCommissionLogs()"
                  :key="ta.external_id"
                >
                  <span class="panel-icon">
                    <i class="fa fa-address-card"></i>
                  </span>
                  {{ta.external_id}} - {{ta.platform}}
                </a>
              </nav>
            </div>

            <div class="column is-9">
              <nav class="level overview">
                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">{{$t('trading_account').tTitle()}}</p>
                    <p class="title">{{modal.selected.ta.external_id}}</p>
                  </div>
                </div>
                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">{{$t('platform').tTitle()}}</p>
                    <p class="title">{{modal.selected.ta.platform}}</p>
                  </div>
                </div>
                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">{{$t('total_commission_generated').tTitle()}}</p>
                    <p class="title">{{$formatMoney(modal.selected.commission, currencies['USD'].symbol)}}</p>
                  </div>
                </div>
                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">{{$t('volume_traded').tTitle()}}</p>
                    <p class="title">{{modal.selected.volume.toFixed(2)}}</p>
                  </div>
                </div>
              </nav>

              <table
                class="table is-striped is-responsive"
                :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
              >
                <thead>
                  <tr>
                    <th>{{$t('order').tTitle()}}</th>
                    <th>{{$t('pair').tTitle()}}</th>
                    <th>{{$t('volume').tTitle()}}</th>
                    <th>{{$t('close_date').tTitle()}}</th>
                    <th>{{$t('commission').tTitle()}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="clog in modal.commissionLogs"
                    :key="clog.order_id"
                  >
                    <td>{{clog.order_id}}</td>
                    <td>{{clog.order_pair}}</td>
                    <td>{{clog.order_volume.toFixed(2)}}</td>
                    <td>{{$formatDateTime(clog.order_close_date)}}</td>
                    <td>{{$formatMoney(clog.calculated_commission, currencies['USD'].symbol)}}</td>
                  </tr>
                </tbody>
              </table>
              <pagination
                ref="modalPagination"
                for="commission-logs"
                :records="modal.totalCommissionLogs"
                :per-page="pagination.maxItemsPerPage"
                :chunk="4"
                :count-text="pagination.total + ' ' + $t('records') "
              ></pagination>
            </div>
          </div>
        </section>
        <footer
          class="modal-card-foot"
          :class="{'left': Language == 'fa' || Language == 'ar', 'right': Language!='fa'}"
        >
          <a
            class="button"
            :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language!='fa'}"
            @click="closeClientDetailsModal()"
          >{{$t('cancel').tTitle()}}</a>
        </footer>
      </div>
    </div>

    <div class="columns daterange">
      <div class="column is-4">
        <div class="columns">
          <div class="column">
            <label class="label">{{$t('name').tUpper()}}</label>
            <input
              v-model="nameSearch"
              name="nameSearch"
              class="input"
              type="text"
              @change="getIBClients(1), $refs.ibClients.setPage(1)"
            />
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="columns">
          <div class="column">
            <label class="label">{{$t('date_from').tUpper()}}</label>
            <datepicker
              v-model="dateFrom"
              name="dateFrom"
              :format="datepicker.format"
              :clear-button="datepicker.clearButton"
              :clear-button-icon="datepicker.clearButtonIcon"
            ></datepicker>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="columns">
          <div class="column">
            <label class="label">{{$t('date_to').tUpper()}}</label>
            <datepicker
              v-model="dateTo"
              name="dateTo"
              :format="datepicker.format"
              :clear-button="datepicker.clearButton"
              :clear-button-icon="datepicker.clearButtonIcon"
            ></datepicker>
          </div>
        </div>
      </div>
    </div>

    <table
      id="ib-clients"
      class="table is-striped is-responsive"
      :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
    >
      <thead>
        <tr>
          <th>{{$t("status").tUpper()}}</th>
          <th
            class="sortable"
            :class="orderClass('date')"
            @click="changeOrderBy('date')"
          >
            {{$t("date_joined").tUpper()}}
            <div class="arrow">
              <div class="line line-1"></div>
              <div class="line line-2"></div>
            </div>
          </th>
          <th
            class="sortable"
            :class="orderClass('fullName')"
            @click="changeOrderBy('fullName')"
          >
            {{$t('full_name').tUpper()}}
            <div class="arrow">
              <div class="line line-1"></div>
              <div class="line line-2"></div>
            </div>
          </th>
          <th
            class="sortable"
            :class="orderClass('commission')"
            @click="changeOrderBy('commission')"
          >
            {{$t('total_commission_generated').tUpper()}}
            <div class="arrow">
              <div class="line line-1"></div>
              <div class="line line-2"></div>
            </div>
          </th>
          <th
            class="sortable"
            :class="orderClass('volume')"
            @click="changeOrderBy('volume')"
          >
            {{$t('volume_traded').tUpper()}}
            <div class="arrow">
              <div class="line line-1"></div>
              <div class="line line-2"></div>
            </div>
          </th>
          <th>{{$t('total_deposits').tUpper()}}</th>
          <th>{{$t('total_withdrawals').tUpper()}}</th>
          <th>{{$t('more').tUpper()}}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="client in IBClients"
          :key="client.client_id"
        >
          <td>{{$statusFormat(client.status)}}</td>
          <td>{{$formatDate(client.date_joined)}}</td>
          <td>{{client.full_name}}</td>
          <td>
            <template v-if="client.total_commission_generated">{{$formatMoney(client.total_commission_generated, currencies['USD'].symbol)}}</template>
          </td>
          <td>{{client.volume_traded}}</td>
          <td>
            <span
              v-for="(value, currency) in client.total_deposits"
              :key="currency"
            >{{$formatMoney(value, currencies[currency].symbol)}}</span>
          </td>
          <td>
            <span
              v-for="(value, currency) in client.total_withdrawals"
              :key="currency"
            >{{$formatMoney(value, currencies[currency].symbol)}}</span>
          </td>
          <td>
            <a
              class="button is-primary is-outlined"
              @click="openClientDetailsModal(client)"
            >
              <span class="icon is-small">
                <i class="fa fa-info"></i>
              </span>
              <span>{{$t('details').tUpper()}}</span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>

    <pagination
      ref="ibClients"
      for="ib-client"
      :records="pagination.total"
      :per-page="pagination.maxItemsPerPage"
      :chunk="4"
      :count-text="pagination.total + ' ' + $t('records') "
    ></pagination>
  </div>
</template>

<script>
import { Pagination, PaginationEvent } from 'vue-pagination-2-bulma'
import { mapActions, mapGetters } from 'vuex'
import { service } from '../../app'
import config from '../../config'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'

export default {
  props: {
    IBID: Number,
  },
  components: {
    Pagination,
    Datepicker,
  },
  data() {
    return {
      _IBID: null,
      IBClients: [],
      currencies: config.currencies,
      pagination: {
        page: 0,
        total: 0,
        maxItemsPerPage: 10,
      },
      orderBy: 'date',
      orderMode: 'desc',
      dateFrom: '',
      dateTo: '',
      nameSearch: '',
      datepicker: {
        clearButton: true,
        clearButtonIcon: 'fa fa-close',
        format: 'dd/MM/yyyy',
      },
      modal: {
        cLogsPage: 1,
        selected: {
          ta: 0,
          client: 0,
          commission: 0,
          volume: 0,
        },
        client: {},
        ta: [],
        commissionLogs: [],
        totalCommissionLogs: 0,
        TAListActive: true,
      },
    }
  },
  watch: {
    dateFrom(df) {
      this.getIBClients(1)
    },
    dateTo(dt) {
      this.getIBClients(1)
    },
    IBID() {
      this.setIBID()
    },
    User() {
      this.setIBID()
    },
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Requests: 'requests/all',
      Language: 'language/code',
    }),
  },
  mounted() {
    // clients pagination
    PaginationEvent.$on('vue-pagination::ib-client', page => {
      this.pagination.page = page
      this.getIBClients(page)
    })
    // commission logs pagination
    PaginationEvent.$on('vue-pagination::commission-logs', page => {
      this.modal.cLogsPage = page
      this.getCommissionLogs(page)
    })

    this.setIBID()
  },
  beforeDestroy() {
    PaginationEvent.$off('vue-pagination::commission-logs')
    PaginationEvent.$off('vue-pagination::ib-client')
  },
  methods: {
    setIBID() {
      if (this.IBID > 0) {
        this._IBID = this.IBID
      } else {
        this._IBID = this.User.info.ID
      }
      this.getIBClients(1)
    },
    openClientDetailsModal(client) {
      this.modal.client = client
      document.getElementById('clientDetails').classList.toggle('is-active')

      this.$refs.modalPagination.setPage(1)
      this.modal.cLogsPage = 1

      // get client trading account(s)
      this['logoLoader/set'](true)
      service
        .post('/ib/clients/ta', {
          userID: this._IBID,
          clientID: client.client_id,
        })
        .then(response => {
          if (response.data.TAs) {
            this.modal.ta = response.data.TAs
            // get first ta's commission logs
            // client/commission-logs
            this.modal.selected.client = client.client_id
            this.modal.selected.ta = this.modal.ta[0]
            this.getCommissionLogs()
          }
          this['logoLoader/set'](false)
        })
        .catch(() => {
          this['logoLoader/set'](false)
        })
    },
    closeClientDetailsModal() {
      document.getElementById('clientDetails').classList.remove('is-active')
    },
    getCommissionLogs(page) {
      if (!this.modal.selected.client) {
        return
      }
      if (!page) {
        if (this.modal.cLogsPage) {
          page = this.modal.cLogsPage
        } else {
          page = 1
        }
      }
      let dateFromUnix = moment(this.dateFrom, 'dd/MM/yyyy').unix()
      let dateToUnix = moment(this.dateTo, 'dd/MM/yyyy').unix()
      if (isNaN(dateFromUnix)) {
        dateFromUnix = 0
      }
      if (isNaN(dateToUnix)) {
        dateToUnix = 0
      }

      this.modal.cLogsPage = page
      this['logoLoader/set'](true)
      service
        .post('/ib/clients/ta/commission-logs', {
          userID: this._IBID,
          clientID: this.modal.selected.client,
          page: page,
          TAID: this.modal.selected.ta.external_id,
          dateFrom: dateFromUnix,
          dateTo: dateToUnix,
        })
        .then(response => {
          this.modal.selected.commission = 0
          this.modal.selected.volume = 0
          this.modal.commissionLogs = []
          if (response.data.commissionLogs) {
            this.modal.commissionLogs = response.data.commissionLogs
          }
          if (response.data.totalCommissionLogs) {
            this.modal.totalCommissionLogs = response.data.totalCommissionLogs
          }
          if (response.data.totalCommission) {
            this.modal.selected.commission = response.data.totalCommission
          }
          if (response.data.totalVolume) {
            this.modal.selected.volume = response.data.totalVolume
          }
          this['logoLoader/set'](false)
        })
        .catch(() => {
          this['logoLoader/set'](false)
        })
    },
    orderClass(name) {
      return this.orderBy === name ? this.orderMode : ''
    },
    changeOrderBy(orderBy) {
      if (this.orderBy === orderBy) {
        this.orderMode = this.orderMode === 'desc' ? 'asc' : 'desc'
      } else {
        this.orderMode = 'desc'
      }
      this.orderBy = orderBy
      this.getIBClients(1)
    },
    getIBClients(page) {
      if (isNaN(parseInt(page))) {
        setTimeout(() => {
          this.getIBClients(1)
        }, 200)
        return
      }
      if (!page) {
        if (this.pagination.page) {
          page = this.pagination.page
        } else {
          page = 1
        }
      }
      let dateFromUnix = moment(this.dateFrom, 'dd/MM/yyyy').unix()
      let dateToUnix = moment(this.dateTo, 'dd/MM/yyyy').unix()
      if (isNaN(dateFromUnix)) {
        dateFromUnix = 0
      }
      if (isNaN(dateToUnix)) {
        dateToUnix = 0
      }

      this['logoLoader/set'](true)
      service
        .post('/ib/clients', {
          userID: this._IBID,
          page: page,
          orderBy: this.orderBy,
          orderMode: this.orderMode || 'desc',
          dateFrom: dateFromUnix,
          dateTo: dateToUnix,
          nameSearch: this.nameSearch,
        })
        .then(response => {
          if (typeof response.data.IBClients !== 'undefined') {
            this.IBClients = response.data.IBClients
            this.pagination.total = response.data.cnt
            // this.orderBy = 'date'
          } else {
            // empty table
            this.IBClients = {}
            this.pagination.total = 0
          }
          this['logoLoader/set'](false)
        })
        .catch(() => {
          this['logoLoader/set'](false)
        })
    },
    ...mapActions(['logoLoader/set', 'user/setIB']),
  },
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/initial-variables';
@import '~bulma/sass/utilities/mixins';
@import '../../assets/css/variables';
$arrow-width: 7px;
// $arrow-height: ($arrow-width * 0.3);
$arrow-height: 2px;
$arrow-angle: 25deg;
$transition-speed: 300ms;

.level.overview {
  // @media screen and (max-width: $tablet) {
  @include mobile {
    .level-item {
      margin-bottom: 5px;
      .heading {
        font-size: 12px;
        margin-bottom: 0px;
      }
      .title {
        font-size: 14px;
      }
    }
  }
}

#clientDetails {
  .modal-card {
    @media screen and (max-width: $tablet) {
      width: 100vw;
      height: calc(100vh - 10px);
      max-height: none;
      margin: 0 5px;
    }
  }

  .talist {
    .mobile-active {
      .panel-block {
        display: block !important;
      }
    }
  }

  .panel {
    max-height: calc(100vh - 330px);
    @media screen and (max-width: $tablet) {
      max-height: calc(100vh - 220px);
    }
    overflow-y: auto;
  }
  .modal-card-head {
    .dates {
      > span {
        margin: 0 10px;
      }
    }
  }
  header {
    min-height: 30px;
    margin: 0;
    padding: 20px 30px;
    p {
      margin-bottom: 0;
    }
  }
}

#ib-clients {
  td {
    font-size: 13px;
    color: #000;
    .icon {
      line-height: 1.5;
    }
  }
}

.overview li {
  span:not(:last-of-type):after {
    content: ',';
  }
}

.daterange {
  margin-bottom: 5px;
  h5 {
    line-height: 35px;
    margin-bottom: 0;
  }
}

th {
  &.sortable {
    padding-right: 24px;
  }
  position: relative;
  cursor: pointer;
  &:hover,
  &:focus {
    .arrow {
      .line-1 {
        transform: rotate($arrow-angle);
      }
      .line-2 {
        transform: rotate(-($arrow-angle));
      }
    }
  }
  &.desc .arrow {
    .line-1 {
      transform: rotate($arrow-angle);
    }
    .line-2 {
      transform: rotate(-($arrow-angle));
    }
  }
  &.asc .arrow {
    .line-1 {
      transform: rotate(-($arrow-angle));
    }
    .line-2 {
      transform: rotate($arrow-angle);
    }
  }

  .arrow {
    display: block;
    position: absolute;
    right: 10px;
    top: 50%;
    width: 10px;
    height: 10px;
    margin-top: -2px;

    padding: 0;
    cursor: pointer;
    width: (($arrow-width * 2) - $arrow-height);
    height: $arrow-height;
    box-sizing: content-box;
    .line {
      position: absolute;
      top: 50%;
      margin-top: -($arrow-height / 2);
      width: $arrow-width;
      height: $arrow-height;
      border-radius: $arrow-height;
      background-color: #fff;
      transition: transform $transition-speed ease, background-color $transition-speed ease;
    }
    .line-1 {
      right: 50%;
      margin-right: -($arrow-height / 2);
    }
    .line-2 {
      left: 50%;
      margin-left: -($arrow-height / 2);
    }
  }
}
</style>

<style lang="scss">
.vdp-datepicker__clear-button {
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  box-shadow: none;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  cursor: pointer;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-left: 0.75em;
  padding-right: 0.75em;
  text-align: center;
  white-space: nowrap;
  i span {
    display: none;
  }
}

.vdp-datepicker input {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// Clients.vue?4fc81b66